import { render } from "./PokemonPage.vue?vue&type=template&id=dc7fafce&scoped=true"
import script from "./PokemonPage.vue?vue&type=script&lang=js"
export * from "./PokemonPage.vue?vue&type=script&lang=js"

import "./PokemonPage.vue?vue&type=style&index=0&id=dc7fafce&scoped=true&lang=css"

import exportComponent from "C:\\Wbb\\Portfolio\\Vue Pokemon\\pokemon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc7fafce"]])

export default __exports__